export const ROLES = [
  {
    name: "user",
    displayName: "User",
  },
];
